import React, { useState } from "react";
import {
    Button,
    Form,
    FormGroup,
    Label,
    Input
} from "reactstrap";


const RoleForm = ({ role, onSubmit, onCancel }) => {
    const [title, setTitle] = useState(role.title);
    const [status, setStatus] = useState(role.status);
    const [overview, setOverview] = useState(role.overview);
    const [alert, setAlert] = useState("");

    const handleSubmit = (event) => {
        if (!title || !status) {
            setAlert("Les champs Nom et status sont obligatoires");
            return;
        }
        event.preventDefault();
        if (role.id != null) {
            onSubmit({ id: role.id, title: title, slug: role.slug, status: status, overview: overview, created_by: role.created_by, created_at: role.created_at, updated_at: role.updated_at });
        } else {
            onSubmit({ title, status, overview });
        }
    };

    return (
        <Form onSubmit={handleSubmit}>
            {alert && <div className="alert alert-danger mt-1">{alert}</div>}
            <FormGroup>
                <Label for="title">Title</Label>
                <Input
                    type="text"
                    name="title"
                    id="title"
                    value={title}
                    onChange={(event) => setTitle(event.target.value)}
                    required={true}
                />
            </FormGroup>
            <FormGroup>
                <Label for="status">Status</Label>
                <Input
                    type="select"
                    name="status"
                    id="status"
                    value={status}
                    onChange={(event) => setStatus(event.target.value)}
                    required={true}
                >
                    <option value="">Sélectionnez le status</option>
                    <option value="1">Actif</option>
                    <option value="0">Inactif</option>
                </Input>
            </FormGroup>
            <FormGroup>
                <Label for="overview">Overview</Label>
                <Input
                    type="textarea"
                    name="overview"
                    id="overview"
                    value={overview}
                    onChange={(event) => setOverview(event.target.value)}
                />
            </FormGroup>
            <Button color="primary" type="submit">
                Submit
            </Button>{" "}
            <Button color="secondary" onClick={onCancel}>
                Cancel
            </Button>
        </Form>
    );
};

export default RoleForm;